import React from "react";
import { Button, ButtonVariant } from "@amzn/stencil-react-components/button";
import camera from "./camera.svg";
import flipCamera from "./flip-camera.svg";
import "./styles.css";

interface IconProps {
  onClick: () => void;
  buttonText?: string;
}

export const IconShot = ({ onClick }: IconProps) => {
  return (
    <img
      onClick={onClick}
      className="icon shot"
      width="100px"
      src={camera}
      alt="Camera button"
    />
  );
};

export const IconStartRecord = ({ onClick }: IconProps) => {
  return (
    <div onClick={onClick} className="icon record">
      <div className="red-circle" />
    </div>
  );
};

export const IconStopRecord = ({ onClick }: IconProps) => {
  return (
    <div onClick={onClick} className="icon record">
      <div className="stop" />
    </div>
  );
};

export const IconFlipCamera = ({ onClick }: IconProps) => {
  return (
    <img
      onClick={onClick}
      className="flip-camera"
      width="64px"
      src={flipCamera}
      alt="Flip camera"
    />
  );
};

export const IconPlay = ({ onClick, buttonText }: IconProps) => {
  return (
      <Button
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          backgroundColor: "rgba(240, 240, 240, 0.3)",
          top: 0,
          bottom: 0,
          border: "4px solid #e6e3d3",
          boxShadow: "0px 5px 15px -2px rgb(97 97 97)",
          position: "absolute",
          left: "0",
          right: "0",
          margin: "auto",
          padding: "12px",
          width: "84px",
          height: "84px",
          borderRadius: "50%",
          cursor: "pointer",
        }}
        onClick={onClick}
        variant={ButtonVariant.Tertiary}
      >
        <span className="play-command">{buttonText}</span>
      </Button>
  );
};
